

/**
 * Scroll j'usqu'à  l'élement si celui ci n'est pas visible
 * @param {Vitesse du scroll} speed 
 */
 $.fn.scrollToElementIfNonVisible = function() {
    try {    
        if(this.length>0 && !this.first().isInViewport()) {           
            $('html, body').animate({
                scrollTop: Math.max(this.offset().top - $('header').height() -30, 0)
            }, 500);
        }
    }
    catch (e){
        console.info(e);
    }
};

/**
 * Scroll j'usqu'à  l'élement que l'élément soit visible ou non
 * @param {Vitesse du scroll} speed 
 */
 $.fn.scrollToElement = function() {
    try {    
        
        $('html, body').animate({
            scrollTop: Math.max(this.offset().top - $('header').height() -30, 0)
        }, 500);        
    }
    catch (e){
        console.info(e);
    }
};


$.fn.isInViewport = function() {
    const rect = this[0].getBoundingClientRect();
    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)

    );
}


/**
 *  Permet de mapper un objet javacsript à des elements du dom
 *  <a id='tel' data-agence-template="tel:{TelephoneFamille}" href="tel:01 77 48 77 88"><span data-agence="TelephoneFamille"></span></a>
 *  $('body').mapObject(agence,'agence');
 *  ==>
 *  <a id='tel' data-agence-template="tel:{TelephoneFamille}" href="tel:02 40 35 97 97"><span data-agence="TelephoneFamille">02 40 35 97 97</span></a>
 */
 $.fn.mapObject = function(objet,mapsuffix='mapping') {
    $(this).find("[data-" +  mapsuffix+"],[data-" +  mapsuffix+"-template]").each(function () {        
        var propertyname = $(this).attr("data-" +  mapsuffix);
        var tpl = $(this).attr("data-"+ mapsuffix +"-template");
        var value="";
        // Si un template est définit on utilise le template, sinon on utilise la variable de data-mapping
        if (tpl!=undefined) {
            properties = Object.getOwnPropertyNames(objet);
            properties.forEach(element => {
                if (objet[element]!=undefined) {
                    value = tpl.replace('{'+element+'}',objet[element]);    
                    tpl = value;
                }
            });

        } else {
            value = objet[propertyname];
        }            
        // map selon le type de tag
        if($(this)[0].tagName=="A") {
            $(this).attr('href',value);
        } else if ($(this)[0].tagName=="IMG") {
            $(this).attr('src',value);
        }        
        else {
            $(this).html(value);
        }
    });

    // Affiche les éléments data-mapping-show="NomDeLaProprite" uniquement si NomDeLaPropiete n'est pas vide
    $(this).find("[data-" +  mapsuffix+"-show]").each(function () {        
        var propertyname = $(this).attr("data-" +  mapsuffix+ "-show");
        var value= objet[propertyname];
        if(typeof(value)!=='undefined' &value!==null) {
            $(this).show();
        } else {
            $(this).hide();
        }
    });

    // Masque les éléments data-mapping-hide="NomDeLaProprite" uniquement si NomDeLaPropiete n'est pas vide
    $(this).find("[data-" +  mapsuffix+"-hide]").each(function () {        
        var propertyname = $(this).attr("data-" +  mapsuffix+ "-hide");
        var value= objet[propertyname];
        if(typeof(value)!=='undefined' &value!==null) {
            $(this).hide();
        } else {
            $(this).show();
        }
    });
}


/**
 *  Function globale Jquery de gestion des calls ajax
 *   - affiche un spinner ajax en ajoutant une classe css au conteneur
 *   - change l'opacité du container pendant le call ajax
 *  Utilisation :
 *   $("#container").loading(promise, cssClass );
 */
/**
 * Affiche un spinner lors de l'vénement ajax
 */
 $.fn.loading = function (promise,cssClassAss="loading-state")
 {
     var self = this;
     this.addClass(cssClassAss);
     // Start loading     
     this.css("opacity","0.7");                          
     promise.then(function(e) {
         // Stop loading        
         self.removeClass(cssClassAss);
         self.css("opacity","1");                
     })
     promise.catch(function(e) {
         // Stop loading         
         self.removeClass(cssClassAss);
         self.css("opacity","1");                         
     });                        
     return this;
 };


